import { DateCalendar, DateField } from "@mui/x-date-pickers";
import moment, { Moment } from "moment";
import { dateFormat } from "../../../misc/dates";
import { TinyButton } from "../../../misc/TinyButton";
import { DueDateCalendarHeader } from "./DueDateCalendarHeader";
import { panelFontSize } from "./PanelSection";

// PickDate is the typed field, shortcuts and month grid shared by the panels that put
// a date on a task
export function PickDate(props: {
    value: string;
    onChange: (value: string) => void;

    // onClear adds a button that takes the date back off, for a field that is allowed
    // to be empty
    onClear?: () => void;
}) {
    return (
        <>
            <div style={{ display: "flex", alignItems: "center", gap: 4, padding: "8px 8px 0 16px" }}>
                <DateField
                    size="small"
                    format="MMM/DD/YYYY"
                    style={{ flex: 1 }}
                    value={props.value ? moment(props.value) : null}
                    onChange={value => {
                        // every keystroke fires a change, so only commit whole dates
                        if (!value || !value.isValid()) return;
                        props.onChange(value.format(dateFormat));
                    }}
                    sx={dateFieldSx}
                />
                <TinyButton color="primary" onClick={() => props.onChange(moment().format(dateFormat))}>
                    Today
                </TinyButton>
                {props.onClear && (
                    <TinyButton disabled={!props.value} onClick={props.onClear}>
                        Clear
                    </TinyButton>
                )}
            </div>

            <DateCalendar
                value={props.value ? moment(props.value) : null}
                onChange={(value: Moment | null) => {
                    if (!value) return;
                    props.onChange(value.format(dateFormat));
                }}
                slots={{ calendarHeader: DueDateCalendarHeader }}
                sx={calendarSx}
            />
        </>
    );
}

const dateFieldSx = {
    "& .MuiPickersInputBase-root": { fontSize: panelFontSize },
    "& .MuiPickersSectionList-root": { padding: "4px 6px" },
};

// DateCalendar ships at 336px tall with generous day cells, which leaves the
// popover mostly empty space next to the time and repeat rows
const dayCell = 30;

const calendarSx = {
    width: "100%",
    height: "auto",
    margin: 0,
    "& .MuiDayCalendar-header, & .MuiDayCalendar-weekContainer": { margin: 0 },
    "& .MuiDayCalendar-weekDayLabel": { width: dayCell, height: dayCell, margin: 0, fontSize: 11 },
    "& .MuiPickersDay-root": { width: dayCell, height: dayCell, margin: 0, fontSize: panelFontSize },
    "& .MuiDayCalendar-slideTransition": { minHeight: dayCell * 6 },
    "& .MuiPickersSlideTransition-root": { minHeight: dayCell * 6 },
};

// panelWidth keeps the date panels at one width, wide enough for the month grid
export const panelWidth = 250;
